import { render, staticRenderFns } from "./product-list.vue?vue&type=template&id=f7e1b3c6&scoped=true"
import script from "./product-list.vue?vue&type=script&lang=js"
export * from "./product-list.vue?vue&type=script&lang=js"
import style0 from "./product-list.vue?vue&type=style&index=0&id=f7e1b3c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e1b3c6",
  null
  
)

export default component.exports